import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { Tooltip, Typography } from "@mui/material";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  DownloadYearlyActivitiesData,
  GetYearlyActivitiesAndCertificateDetails,
  DownloadShareCertificateData,
  CreateEmailForYearlyDividend,
  CreateEmailForShareCertificate,
} from "../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import {
  getActionEditForLoanDashboard,
  getStatusIdsForLoanDashboard,
} from "../../Pages/LoanApproval/Helpers/GridHelper";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { IActivityGrid } from "./Grid/YearlyActGrid";
// import { AppModules } from "../../Helpers/Enums/AppModules";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import axios from "axios";
import fileDownload from "js-file-download";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import CustomModal from "../../Components/Modal/CustomModal";
import { Modal, Button } from "react-bootstrap";
import ButtonComponent from "../../Components/ButtonForm/Button";
import ConfirmationModal from "../Common/SendMailModel/MailModel"; 
import MailModel from "../Common/SendMailModel/MailModel";
const YearlyActivitiesGrid = (props: IActivityGrid) => {
  const {
    searchText,
    setSearchText,
    activeTab,
    currentFilters,
    dataCount,
    setDataCount,
  } = props;

  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [dashboardData, setDashboardData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // const [selectedPdfUrl, setSelectedPdfUrl] = useState("");
  const [modalOpen3, setModalOpen3] = React.useState(false);
  const [selectedId, setSelectedId] = useState(null);
// Send Mail Model 
  const [mailModalOpen, setMailModalShow] = useState(false);
  // const handleOpenModalForSendMail = () => setModalShow(true);
  // const handleCloseModalForSendMail = () => setModalShow(false);


  const getDashboardData = async () => {
    showLoader();
    try {
      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        // FromDate: currentFilters?.fromDate || "",
        // ToDate: currentFilters?.toDate || "",
        OpratingYear: currentFilters?.FinancialYear || "",
        MemberId: context.MemberId,
        RoleId: context?.CurrentRoleId,
      };

      // Yearly Divided
      if (activeTab.id === "Yearly-Divided") {
        const resp = await APICall(
          GetYearlyActivitiesAndCertificateDetails,
          obj
        );
        if (resp?.Data?.YearlyActivitiesDetails.length > 0) {
          setDashboardData(resp?.Data.YearlyActivitiesDetails);
          const dataCount = resp?.Data?.YearlyActivitiesDetails.TotalCount;
          setDataCount(dataCount ?? 0);
          hideLoader();
        } else {
          setDashboardData([]);
          setDataCount(0);
          hideLoader();
        }
      }
      // Share Certificate
      else if (activeTab.id === "Share-Certificate") {
        const resp = await APICall(
          GetYearlyActivitiesAndCertificateDetails,
          obj
        );
        if (resp?.Data?.ShareCertificateDetails.length > 0) {
          setDashboardData(resp?.Data.ShareCertificateDetails);
          const dataCount = resp?.Data?.ShareCertificateDetails.TotalCount;
          setDataCount(dataCount ?? 0);
          hideLoader();
        } else {
          setDashboardData([]);
          setDataCount(0);
          hideLoader();
        }
      }
    } catch (err) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {/* {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""} */}
            {isDate ? moment(value).format(DATE_DISPLAY_FORMAT) : value}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  //Columns
  const GridColumns = [
    //0
    {
      name: "MemberNo",
      label: "Member No.",
      options: {
        display: context?.CurrentRoleId === RoleEnum.InternalTeam,
      },
    },
    //1
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    //2
    {
      name: "Name",
      label: "Name",
      options: {
        display: context?.CurrentRoleId === RoleEnum.InternalTeam,
      },
    },
    //3
    {
      name: "OpratingYear",
      label: "Financial year",
      options: CommonCellOptions(),
    },
    //4
    {
      name: "Link",
      label: "Download Link",
      options: {
        filter: false,
        sort: false,
        display: context?.CurrentRoleId === RoleEnum.Member,
        customBodyRender: (value, tableMeta) => (
          <a
            style={{
              color: "black",
              textDecoration: "none",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "blue")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleOpenPDF(tableMeta.rowData[1])}
          >
            {value}
          </a>
        ),
      },
    },
    // {
    //   name: "Link",
    //   label: "Link",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => (
    //       <a
    //         // href={"value"}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         // onClick={() =>
    //         //    handleDownloadPDF(tableMeta.rowData[1])
    //         //   }
    //         onClick={() => handleOpenPDF(tableMeta.rowData[2])}
    //       >
    //         Open PDF
    //       </a>
    //     ),
    //   },
    // },
    //5
    {
      name: "Link",
      label: "Download",
      options: {
        filter: false,
        sort: false,
        display: context?.CurrentRoleId !== RoleEnum.InternalTeam,
        customBodyRender: (value, tableMeta) => {
          const IdFromList = tableMeta.rowData[1];
          return (
            <>
              <Tooltip title="Download">
                <a
                  onClick={() => {
                    handleDownloadPDF(IdFromList, true);
                  }}
                >
                  <i className="fas fa-file-download"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
    //6     {/* open modal when role is internal team to download duplicate and orignal pdf */}
    {
      name: "Link",
      label: "Download",
      options: {
        filter: false,
        sort: false,
        display:
          context?.CurrentRoleId === RoleEnum.InternalTeam &&
          activeTab.id === "Share-Certificate",
        customBodyRender: (value, tableMeta) => {
          const IdFromList = tableMeta.rowData[1];
          return (
            <>
              <Tooltip title="Download">
                <a
                  onClick={() => {
                    setSelectedId(IdFromList);
                    setModalOpen3(true);
                  }}
                >
                  <i className="fas fa-file-download"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
    //7
    {
      name: "Link",
      label: "Download",
      options: {
        filter: false,
        sort: false,
        display:
          context?.CurrentRoleId === RoleEnum.InternalTeam &&
          activeTab.id === "Yearly-Divided",
        customBodyRender: (value, tableMeta) => {
          const IdFromList = tableMeta.rowData[1];
          return (
            <>
              <Tooltip title="Download">
                <a
                  onClick={() => {
                    handleDownloadPDF(IdFromList, true);
                  }}
                >
                  <i className="fas fa-file-download"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
    //8
    {
      name: "SendMail",
      label: "Send mail",
      options: {
        filter: false,
        sort: false,
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,

        customBodyRender: (value, tableMeta) => {
          const IdFromList = tableMeta.rowData[1];
          return (
            <Tooltip title="Send Mail">
              <a
                onClick={() => {
                   handleSendMail();
                  setSelectedId(IdFromList);
                }}
              >
                <i className="fas fa-envelope"></i>
              </a>
            </Tooltip>
            
          );
        },
      },
    },
  ];

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const handleSendMail = async () => {
    showLoader();
    setMailModalShow(true);
    // console.log('Id of model '+IdFromList);
    hideLoader()

    // try {
    //   let requestParams = {
    //     Id: IdFromList,
    //     isOrignal: true,
    //   };
    //   if (activeTab.id === "Yearly-Divided") {
    //     const req = await APICall(CreateEmailForYearlyDividend, requestParams);
    //     if ((req.Message = "Mail Send Succesfully.")) {
    //       notify(0, "Mail Send Succesfully.");
    //     }
    //   } else if (activeTab.id === "Share-Certificate") {
    //     const req = await APICall(
    //       CreateEmailForShareCertificate,
    //       requestParams
    //     );
    //     if ((req.Message = "Mail Send Succesfully.")) {
    //       notify(0, "Mail Send Succesfully.");
    //     }
    //   }
    // } catch (err) {
    //   notify(
    //     ToastType.Error,
    //     "Oops! Something went wrong. We're on it. Please try again later."
    //   );
    // } finally {
    //   hideLoader();
    // }
  };

  const handleOpenPDF = async (IdFromList) => {
    showLoader();
    // setModalOpen(true);
    let requestParams = {
      Id: IdFromList,
      isOrignal: true,
    };
    let token = await fetchAuthToken();
    let pdfUrl = "";
    if (activeTab.id === "Yearly-Divided") {
      pdfUrl = DownloadYearlyActivitiesData;
    } else if (activeTab.id === "Share-Certificate") {
      pdfUrl = DownloadShareCertificateData;
    }

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: pdfUrl,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Open the PDF in a new tab
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(file);
        window.open(`${fileUrl}#toolbar=0`, "_blank");
        // const iframe = document.getElementById(
        //   "pdfIframe"
        // ) as HTMLIFrameElement;
        // if (iframe) {
        //   iframe.src = `${fileUrl}#toolbar=0&zoom=100`;
        // }
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
       
      });
  };

  const handleDownloadPDF = async (IdFromList, isOrignal) => {
    
    if (
      context?.CurrentRoleId === RoleEnum.InternalTeam &&
      activeTab.id === "Share-Certificate"
    ) {
      setModalOpen3(true);
    }

    showLoader();
    let requestParams = {
      Id: IdFromList,
      isOrignal: isOrignal,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    if (activeTab.id === "Yearly-Divided") {
      fileNamePrefix = "Yearly_Divided";
    } else if (activeTab.id === "Share-Certificate") {
      fileNamePrefix = "Share_Certificate";
    }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url:
          activeTab.id === "Yearly-Divided"
            ? DownloadYearlyActivitiesData
            : DownloadShareCertificateData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}_${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );
        setModalOpen3(false);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
        setModalOpen3(false);
      
      });
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleMailClose = () => {
    setMailModalShow(false);
  };

  const handleMailConfirm = async () => {
   
    showLoader();
    setMailModalShow(true);
  
   

    try {
      let requestParams = {
        Id: selectedId,
        isOrignal: true,
      };
      if (activeTab.id === "Yearly-Divided") {
        const req = await APICall(CreateEmailForYearlyDividend, requestParams);
        if ((req.Message = "Mail Send Succesfully.")) {
          notify(0, "Mail Send Succesfully.");
          setMailModalShow(false);
        }
      } else if (activeTab.id === "Share-Certificate") {
        const req = await APICall(
          CreateEmailForShareCertificate,
          requestParams
        );
        if ((req.Message = "Mail Send Succesfully.")) {
          notify(0, "Mail Send Succesfully.");
          setMailModalShow(false);
        }
      }
    } catch (err) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (activeTab != null) {
      getDashboardData();
    }
  }, [activeTab, start, sortColumn, sortDirection, searchText, currentFilters]);

  return (
    <div>
      {/* To check user want to download orignal or duplicat PDF */}
      <Modal
        show={modalOpen3}
        onHide={() => setModalOpen3(false)}
        keyboard={false}
      >
        <Modal.Header className="custom-modal-header my_close_btn" closeButton>
          <Modal.Title>Please Select one</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Which certificate you want to download ?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center">
            <ButtonComponent
              icon={""}
              className="btn btn-cancel"
              style={{ marginLeft: 5 }}
              onClick={() => {
                handleDownloadPDF(selectedId, false);
              }}
              value={"Duplicate"}
              id={"DuplicateBtn"} 
            />
            <ButtonComponent
              icon={""}
              value={"Original"}
              style={{ marginLeft: "10px" }}
              id={"Original"}
              onClick={() => handleDownloadPDF(selectedId, true)}
            />
          </div>
        </Modal.Footer>
      </Modal>

      {/* To open pd fin popup message currently not used */}
      <Modal
        show={modalOpen}
        onHide={handleCloseModal}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="custom-modal-header my_close_btn" closeButton>
          <Modal.Title>Please Select one</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: "70vh" }}>
            <iframe
              id="pdfIframe"
              title="pdf"
              frameBorder="0"
              scrolling="auto"
              height="100%"
              width="100%"
              sandbox="allow-downloads allow-popups"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center">
            <ButtonComponent
              icon={"far fa-times-circle"}
              className="btn btn-cancel"
              style={{ marginLeft: 5 }}
              onClick={handleCloseModal}
              value={"Cancel"}
              id={"cancelBtn"}
            />
            {/* <ButtonComponent
              icon={"fas fa-paper-plane"}
              value={"Submit"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={() => {}}
            /> */}
          </div>
        </Modal.Footer>
      </Modal>

      <MailModel show={mailModalOpen} handleClose={handleMailClose} handleConfirm={handleMailConfirm} />

      <DynamicGrid
        options={Options}
        data={dashboardData}
        columns={GridColumns}
      />
    </div>
  );
};

export default YearlyActivitiesGrid;
